// extracted by mini-css-extract-plugin
export default {"our-numbers-grid":"styles_our-numbers-grid__U8Uv+"};